import type { SVGProps } from 'react';

export const MurekaIcon = ({
  className,
  width,
  height,
}: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
    role="img"
    aria-label="Mureka"
    className={className}
    width={width}
    height={height}
  >
    <rect width="100" height="100" rx="22" fill="#14E6E6" />
    <path
      d="M18 56 L34 42 L48 60 L62 40 L72 59 L84 48"
      fill="none"
      stroke="#0A0A0A"
      strokeWidth="14"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
